var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSimExpired(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m13.906 13.14-3.37-2V6.61c0-.4-.32-.72-.72-.72h-.06c-.4 0-.72.32-.72.72v4.72c0 .35.18.68.49.86l3.65 2.19c.34.2.78.1.98-.24.21-.35.1-.8-.25-1Zm5.31-10.24L16.136.34c-.42-.35-1.05-.3-1.41.13-.35.42-.29 1.05.13 1.41l3.07 2.56c.42.35 1.05.3 1.41-.13a1 1 0 0 0-.12-1.41ZM2.136 4.44l3.07-2.56c.43-.36.49-.99.13-1.41a.988.988 0 0 0-1.4-.13L.856 2.9a1 1 0 0 0-.12 1.41c.35.43.98.48 1.4.13Zm7.9-2.55a9 9 0 1 0 .002 18.002 9 9 0 0 0-.002-18.001Zm0 16c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimExpired);
export default __webpack_public_path__ + "static/media/SimExpired.dec14debd9e0dfb47c34666ddccd179c.svg";
export { ForwardRef as ReactComponent };